<template>
  <span>
    <button
      class="p-link layout-topbar-chat"
      @click="openSidebar"
      v-tooltip.left="'Ordens de Serviço LG / Hisense'"
    >
      <span class="layout-topbar-icon-wrapper">
        <span class="layout-topbar-icon pi pi-wrench"></span>
        <span class="chat-notification-ping" v-if="totalPending > 0" aria-hidden="true">
          <span class="chat-notification-ping-outer"></span>
          <span class="chat-notification-ping-inner"></span>
        </span>
      </span>
    </button>
  </span>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ServiceOrdersTopbarIndicator',
  data() {
    return {
      timer: null,
    };
  },
  computed: {
    ...mapGetters('serviceOrdersIndicator', ['totalPending']),
  },
  created() {
    this.fetchCounts();
    this.timer = setInterval(() => this.fetchCounts(), 5 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    ...mapActions('serviceOrdersIndicator', ['fetchCounts', 'toggleSidebar']),
    openSidebar() {
      this.toggleSidebar(true);
    },
  },
};
</script>


